import React, { useEffect, useRef } from "react"
import { Animated, FlatList, SectionList } from "react-native"
import { theme } from "../../theme/theme"
import { IS_WEB } from "../../utils/mobileUtils"

export function ListGroupM(props) {
    const {
        options,
        renderItem,
        initialScrollIndex = 0,
        itemHeight,
        style,
        sectionMode = false,
        renderSectionHeader,
        contentContainerStyle,
        scrollEnabled = true,
        animation = false,
    } = props

    const animatedValues = useRef(
        options?.map(() => new Animated.Value(0))
    ).current

    useEffect(() => {
        if (animation && animatedValues?.length > 0) {
            const animations = options?.map((_, index) =>
                Animated.timing(animatedValues[index], {
                    toValue: 1,
                    duration: 300,
                    delay: index * 100,
                    useNativeDriver: true,
                })
            )

            Animated.stagger(100, animations).start()
        } else {
            animatedValues.forEach((value) => value.setValue(1))
        }
    }, [options, animatedValues, animation])

    const renderAnimatedItem = ({ item, index }) => {
        if (animation) {
            const opacity = animatedValues[index]
            const translateY = animatedValues[index]?.interpolate({
                inputRange: [0, 1],
                outputRange: [20, 0],
            })

            return (
                <Animated.View
                    style={{
                        opacity,
                        transform: [{ translateY }],
                    }}
                >
                    {renderItem({ item, index })}
                </Animated.View>
            )
        } else {
            return renderItem({ item, index })
        }
    }

    return (
        <>
            {!sectionMode ? (
                <FlatList
                    data={options}
                    initialScrollIndex={IS_WEB ? null : initialScrollIndex}
                    getItemLayout={(data, index) => ({
                        length: itemHeight,
                        offset: itemHeight * index,
                        index,
                    })}
                    scrollEnabled={scrollEnabled}
                    style={{
                        ...(animation
                            ? { backgroundColor: theme.colors.white }
                            : {
                                  borderWidth: 1,
                                  borderRadius: 15,
                                  borderColor: theme.colors.lightMore,
                              }),
                        marginTop: 10,
                        marginBottom: 20,
                        flexGrow: IS_WEB ? null : 0,
                        width: "100%",
                        ...style,
                    }}
                    contentContainerStyle={{
                        borderRadius: 15,
                        overflow: "hidden",
                        ...contentContainerStyle,
                    }}
                    keyExtractor={(item, index) => index.toString()}
                    renderItem={animation ? renderAnimatedItem : renderItem}
                />
            ) : (
                <SectionList
                    sections={options}
                    stickySectionHeadersEnabled={false}
                    initialScrollIndex={IS_WEB ? null : initialScrollIndex}
                    keyExtractor={(item, index) => item + index}
                    renderSectionHeader={renderSectionHeader}
                    getItemLayout={(data, index) => ({
                        length: itemHeight,
                        offset: itemHeight * index,
                        index,
                    })}
                    style={{
                        borderWidth: 1,
                        borderRadius: 15,
                        borderColor: theme.colors.lightMore,
                        marginTop: 10,
                        marginBottom: 20,
                        flexGrow: 0,
                        width: "100%",
                        ...style,
                    }}
                    contentContainerStyle={{
                        ...contentContainerStyle,
                    }}
                    renderItem={renderItem}
                />
            )}
        </>
    )
}
